import type { Content, GroupField, KeyTextField } from '@prismicio/client';
import { memo } from 'react';
import type { Simplify } from '../../../../../prismicio-types';
import { StatisticsItem } from './StatisticsItem/StatisticsItem';

import { useVisible } from '@/hooks';
import styles from './statistics.module.scss';

interface StatisticsProps {
  heading: KeyTextField;
  description: KeyTextField;
  statistics: GroupField<
    Simplify<Content.ChartSliceDefaultPrimaryStatisticsItem>
  >;
}

const StatisticsComponent = ({
  description,
  heading,
  statistics,
}: StatisticsProps) => {
  const [isVisible, id] = useVisible();
  const isVisibleStyles = isVisible ? styles.isVisible : '';
  return (
    <article className={styles.statistics} id={id}>
      <div className={`${styles.heading_wrapper} ${isVisibleStyles}`}>
        <span className={styles.heading}>{heading}</span>
        <p className={styles.description}>{description}</p>
      </div>
      <ul className={`${styles.list} ${isVisibleStyles}`}>
        {statistics.map((item, index) => (
          <StatisticsItem data={item} key={item.description} index={index} />
        ))}
      </ul>
    </article>
  );
};

export const Statistics = memo(StatisticsComponent);
